/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setFilterObserver() {
    if (window.innerWidth > 768) return;

    if (FacetFiltersForm.footerObserver) {
      FacetFiltersForm.footerObserver.disconnect();
      FacetFiltersForm.footerObserver = null;
    }

    const footer = document.getElementById('footer');
    if (!footer) return;

    FacetFiltersForm.footerObserver = new IntersectionObserver(([entry]) => {
      const facetBar = document.querySelector('facet-filters-form.facets--bar');
      if (!facetBar) return;

      if (entry.isIntersecting) {
        facetBar.classList.add('hide-view');
      } else {
        facetBar.classList.remove('hide-view');
      }
    }, { threshold: 0.2 });

    FacetFiltersForm.footerObserver.observe(footer);
  }

  static setListeners() {
    FacetFiltersForm.setFilterListeners();
    FacetFiltersForm.setFilterObserver();
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static setFilterListeners() {
    const mobileFilterLabels = document.querySelectorAll('.mobile-filter-label__item');
    const mobileFilterValues = document.querySelectorAll('.mobile-filter-value__item');
    const filterOptionSearch = document.querySelectorAll('.filter-option-search');

    mobileFilterLabels.forEach((label) => {
      label.addEventListener('click', (event) => {
        event.preventDefault();

        if (label.classList.contains('active')) {
          return;
        }

        filterOptionSearch.forEach(search => search.reset());
        const filterIndex = label.dataset.filterIndex;

        mobileFilterLabels.forEach(l => l.classList.remove('active'));
        mobileFilterValues.forEach(v => v.classList.remove('active'));

        label.classList.add('active');
        mobileFilterValues.forEach((value) => {
          if (value.dataset.filterIndex === filterIndex) {
            value.classList.add('active');
          }
        });
      });
    });

  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    FacetFiltersForm.setFilterObserver();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    const updateElements = [
      { selector: '.filter-values-list__item', property: 'innerHTML' },
      { selector: '.mobile-filter-label__item-label', property: 'textContent' }
    ];

    updateElements.forEach(({ selector, property }) => {
      const currentElements = document.querySelectorAll(selector);
      const newElements = parsedHTML.querySelectorAll(selector);

      const minLength = Math.min(currentElements.length, newElements.length);
      for (let i = 0; i < minLength; i++) {
        currentElements[i][property] = newElements[i][property];
      }
    });
    FacetFiltersForm.setFilterListeners();
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const filteredFormData = new FormData();
    let hasSortByInForm = false;

    for (const [key, value] of formData.entries()) {
      if (key !== 'filter-search-input-field') {
        filteredFormData.append(key, value);
        if (key === 'sort_by') {
          hasSortByInForm = true;
        }
      }
    }

    if (!hasSortByInForm) {
      const currentUrl = new URL(window.location);
      const currentSortBy = currentUrl.searchParams.get('sort_by');
      if (currentSortBy) {
        filteredFormData.append('sort_by', currentSortBy);
      }
    }

    const searchParams = new URLSearchParams(filteredFormData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }

    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.footerObserver = null;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('shopify:section:load', () => {
  FacetFiltersForm.setFilterObserver();
});
document.addEventListener('shopify:section:select', () => {
  FacetFiltersForm.setFilterObserver();
});
document.addEventListener('shopify:section:deselect', () => {
  FacetFiltersForm.setFilterObserver();
});


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});

class FakeSelectElement extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.selectId = this.dataset.selectId;
    this.originalSelect = document.getElementById(this.selectId);

    this.bindEvents();
    this.init();
  }

  bindEvents() {
    this.textElement = this.querySelector('.selected-text');
    this.listElement = this.querySelector('.selection-list');
    this.options = this.querySelectorAll('.option');
    this.fakeSelectContainer = this.querySelector('.fake-select-container');
    this.fakeSelectCloseIcon = this.querySelector('.fake-select-list--close-icon');
    this.sortBySelectLabel = this.querySelector('.sort-by-select-label');


    [this.sortBySelectLabel, this.fakeSelectContainer].forEach(element => {
      element.addEventListener('click', (e) => {
        if (this.isOpen) return;
        e.stopPropagation();
        this.toggle();
      });
    });

    this.fakeSelectCloseIcon.addEventListener('click', (e) => {
      if (this.isOpen) {
        e.stopPropagation();
        this.close();
      }
    });

    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectOption(option);
      });
    });

    document.addEventListener('click', (e) => {
      const triggerClasses = ['facets-bar__sort--fake', 'fake-select-list-title', 'fake-select-list-title-text', 'fake-select-title__wrapper'];
      if (triggerClasses.some(className => e.target.classList.contains(className))) return;
      this.close();
    });
  }

  init() {
    const selectedOption = this.querySelector('.option.selected');
    if (selectedOption && this.originalSelect) {
      selectedOption.dataset.value = selectedOption.textContent;
      this.textElement.textContent = selectedOption.textContent;
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.classList.toggle('open', this.isOpen);
  }

  close() {
    this.isOpen = false;
    this.classList.remove('open');
  }

  selectOption(selectedOption) {
    const value = selectedOption.dataset.value;
    const text = selectedOption.textContent;

    this.options.forEach(opt => opt.classList.remove('selected'));
    selectedOption.classList.add('selected');
    this.textElement.textContent = text;

    if (this.originalSelect) {
      this.originalSelect.value = value;
      this.originalSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }
    this.close();
  }
}

customElements.define('fake-select', FakeSelectElement);

class GridViewToggleElement extends HTMLElement {
  connectedCallback() {
    this.replaceClassString = this.dataset.replaceClassString;
    this.target = document.querySelector(this.dataset.targetId);

    this.querySelectorAll('[data-target-view]').forEach(icon => {
      icon.addEventListener('click', () => {
        this.querySelectorAll('[data-target-view]').forEach(i => i.classList.remove('selected'));
        icon.classList.add('selected');
        this.target.className = this.target.className.replace(new RegExp(`${this.replaceClassString}\\d+`, 'g'), '') + ' ' + icon.dataset.targetView;
      });
    });

    this.updateSortByIcon();

    // Listen for URL changes (if needed for SPA behavior)
    window.addEventListener('popstate', () => {
      this.updateSortByIcon();
    });
  }

  updateSortByIcon() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByActiveIcon = document.querySelector('.sort-by-active-icon');

    if (sortByActiveIcon) {
      if (urlParams.has('sort_by')) {
        sortByActiveIcon.classList.remove('is-hidden');
      } else {
        sortByActiveIcon.classList.add('is-hidden');
      }
    }
  }
}

customElements.define('grid-view-toggle', GridViewToggleElement);

class FilterOptionSearch extends HTMLElement {
  constructor() {
    super();
    this.searchInput = null;
    this.filterContainer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.searchInput = this.querySelector('#filter-search-input-field');
    this.filterContainer = this.closest('.filter-values__container');

    if (!this.searchInput || !this.filterContainer) {
      console.warn('FilterOptionSearch: Required elements not found');
      return;
    }

    this.searchInput.addEventListener('input', (e) => {
      this.handleSearch(e.target.value);
    });

    this.searchInput.addEventListener('focus', () => {
      if (this.searchInput.value.trim() === '') {
        this.clearSearch();
      }
    });
  }

  handleSearch(searchValue) {
    const trimmedValue = searchValue.trim().toLowerCase();
    const activeFilterItem = this.filterContainer.querySelector('.mobile-filter-value__item.active');

    if (!activeFilterItem) {
      return;
    }

    const searchEnabled = activeFilterItem.getAttribute('data-filter-search-enabled') === 'true';
    if (!searchEnabled) {
      return;
    }

    const filterListItems = activeFilterItem.querySelectorAll('.filter-values-list__item');
    if (trimmedValue === '') {
      this.clearSearch();
      return;
    }

    filterListItems.forEach(item => {
      const searchAttributeValue = item.getAttribute('data-filter-search-value');
      if (searchAttributeValue) {
        const itemText = searchAttributeValue.toLowerCase();

        if (itemText.includes(trimmedValue)) {
          item.classList.remove('is-hidden');
        } else {
          item.classList.add('is-hidden');
        }
      }
    });
  }

  clearSearch() {
    const activeFilterItem = this.filterContainer.querySelector('.mobile-filter-value__item.active');
    if (activeFilterItem) {
      const filterListItems = activeFilterItem.querySelectorAll('.filter-values-list__item');
      filterListItems.forEach(item => {
        item.classList.remove('is-hidden');
      });
    }
  }

  reset() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.clearSearch();
    }
  }

  focus() {
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }

  disconnectedCallback() {
    if (this.searchInput) {
      this.searchInput.removeEventListener('input', this.handleSearch);
      this.searchInput.removeEventListener('focus', this.clearSearch);
    }
  }
}

customElements.define('filter-option-search', FilterOptionSearch);
